export default "__VITE_ASSET__054531d0__"